import { useSelector } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import frozenEmoji from '@shared/assets/emoji/frozen.svg';
import Logo from '@shared/assets/Logo';
import { roles } from '@shared/static/roles';
import { Avatar } from '@shared/ui/parts';
import { theme } from '@utils/libs/theme';
import { EmailBtn, TelegramBtn } from '@widgets/buttons';

const noteKeys = {
  [roles.TEAM_LEAD]: 'access_frozen_lead_note',
  [roles.TEAM_MEMBER]: 'access_frozen_member_note',
};

export default function DashboardFrozen() {
  const { user, isFrozenGroup } = useSelector((state) => state.user);
  const { t } = useTranslation();
  const { telegram, email, name } = user.superior_contacts?.[0] ?? {};
  const group = user.groups?.[0];
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className="dashboardFrozen block-pd-x block-pd-y main-section">
      {isMobile && <Logo />}
      <div className="dashboardFrozen__content">
        <img className="dashboardFrozen__img" src={frozenEmoji} alt="" />
        {!isFrozenGroup ? (
          <p className="dashboardFrozen__title">{t('access_frozen')}</p>
        ) : user.groups?.length === 1 ? (
          <div className="dashboardFrozen__title">
            <Trans
              i18nKey="access_group_frozen"
              values={{ name: group.name }}
              components={{
                div: <div className="dashboardFrozen__title-team" />,
                icon: <Avatar team={group} />,
              }}
            />
          </div>
        ) : (
          <div className="dashboardFrozen__title">
            <Trans i18nKey="access_all_group_frozen" />
          </div>
        )}

        <p className="secondary-text body-18r">
          {noteKeys[user.group_role] && (
            <Trans
              i18nKey={noteKeys[user.group_role]}
              values={{ name }}
              components={{ span: <span className="body-18r primary-text" /> }}
            />
          )}
          {!user.group_role && t('please_contact_support_to_restore_access')}
        </p>
      </div>
      <div className="dashboardFrozen__btns block-pd-y">
        {!user.group_role ? (
          <TelegramBtn
            text={t('Support')}
            appearance="primary"
            startIcon="chat"
          />
        ) : (
          <>
            {telegram && <TelegramBtn username={telegram} />}
            {email && <EmailBtn email={email} />}
          </>
        )}
      </div>
    </div>
  );
}
